import { useCallback } from 'react';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { useDispatch } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { all, fork, takeEvery } from 'typed-redux-saga';
import { createReducer } from 'typesafe-actions';
import { DialogAction } from '@smart-builder/types';
import { dialogsReducer, dialogsWatches } from '../index';
import {
  afterCloseDialog,
  closeDialog,
  closeDialogSaga,
  handleAfterCloseDialog,
  handleCloseDialog,
} from './closeDialog';
import { handleShowDialog, showDialog } from './showDialog';
import { DialogsState } from './types';

const initialState: DialogsState = {
  dialogs: [],
};

export * from './util';
export { showDialog, closeDialog };

export const reducer = createReducer(initialState)
  .handleAction(showDialog, handleShowDialog)
  .handleAction(closeDialog, handleCloseDialog)
  .handleAction(afterCloseDialog, handleAfterCloseDialog);

export function* watches(): Generator {
  yield all([takeEvery(closeDialog, closeDialogSaga)]);
}

export const useCloseDialog = () => {
  const dispatch = useDispatch();
  return useCallback(
    (action?: DialogAction) => {
      dispatch(
        closeDialog({ result: { action: action ?? DialogAction.Cancel } }),
      );
    },
    [dispatch],
  );
};

// for apps that don't have any redux except this dialog
export const dialogOnlyStore = () => {
  type AppState = {
    dialogs: DialogsState;
  };

  const rootReducer = combineReducers<AppState>({
    dialogs: dialogsReducer,
  });

  const sagaMiddleware = createSagaMiddleware();
  const composeEnhancer =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  function* rootSaga(): Generator {
    yield all([fork(dialogsWatches)]);
  }

  const store = createStore(
    rootReducer,
    {},
    composeEnhancer(applyMiddleware(sagaMiddleware)),
  );

  sagaMiddleware.run(rootSaga);

  return store;
};
